<template>
	<div>
		<sf-modal-layout class="qms-xxl" :title="getMessage_('QWCC001655')" :show="show" :closeModal="close">
			<sf-data-table
				ref="popupTable"
				:columns="columns"
				:rows="pvoResultList"
				height="82vh"
				selection
				fit="fit"
				:stripe="false"
				:excel="isButton_(scrId, 'EX')"
			>
				<template v-slot:actionsLeft>
					<!-- 불출 -->
					<sf-button v-if="isButton_(scrId, 'CU')" line icon="export" :onClick="pvoAction">
						{{ getMessage_('QWCC001634') }}
					</sf-button>
				</template>
				<template v-slot:customRows="slotProps">
					<!-- 불출일자 -->
					<template v-if="slotProps.column.property === 'pvoDd'">
						<el-date-picker
							:value="slotProps.row.pvoDd?.replaceAll('-', '')"
							@input="val => changeInput(val, 'pvoDd', slotProps.row)"
							format="yyyy-MM-dd"
							value-format="yyyyMMdd"
							placeholder="yyyy-MM-dd"
						>
						</el-date-picker>
					</template>
					<!-- 불출시간 -->
					<template v-if="slotProps.column.property === 'pvoDt'">
						<el-time-picker
							:value="slotProps.row.pvoDt"
							@input="val => changeInput(val, 'pvoDt', slotProps.row)"
							value-format="HHmm"
							format="HH:mm"
							placeholder="HH:mm"
						>
						</el-time-picker>
					</template>
					<!-- 인수자 -->
					<template v-if="slotProps.column.property === 'pwtiNm'">
						<div class="position-relative h-100">
							<el-input
								class="pr-2"
								v-model="slotProps.row.pwtiNm"
								:placeholder="getMessage_('QWCC001656')"
								@keyup.native.delete="() => onUserInPutKeyDown('pwti')"
								readonly
							>
							</el-input>
							<span class="unit input-icon">
								<i class="icon-sf-search search-icon" @click="() => onUserPopup('pwti', slotProps.row)"></i>
							</span>
						</div>
					</template>
					<!-- 불출자 -->
					<template v-if="slotProps.column.property === 'pvorNm'">
						<div class="position-relative h-100">
							<el-input
								class="pr-2"
								v-model="slotProps.row.pvorNm"
								:placeholder="getMessage_('QWCC001656')"
								@keyup.native.delete="() => onUserInPutKeyDown('pvor')"
								readonly
							>
							</el-input>
							<span class="unit input-icon">
								<i class="icon-sf-search search-icon" @click="() => onUserPopup('pvor', slotProps.row)"></i>
							</span>
						</div>
					</template>
				</template>
			</sf-data-table>
		</sf-modal-layout>
		<user-popup-view ref="userPopupView" @SendData="sendData" :scrId="scrId" />
	</div>
</template>

<script>
import _ from 'lodash';
import * as Yup from 'yup';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mmc/mmcm/MesCalPvo/store/helpers';
import UserPopupView from '@qms/comm/commpopup/UserPopup/UserPopupView.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { UserPopupView },

	data() {
		return {
			show: false,
			selectedRow: {}
		};
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		open() {
			this.show = true;
		},
		close() {
			this.refresh();
			this.show = false;
		},
		refresh() {
			this.setState_({ key: 'pvoResultList', value: [] });
			this.$emit('Refresh');
		},
		changeInput(value, key, row) {
			try {
				if (key === 'pvoDd') {
					if (value > this.$moment().format('YYYYMMDD')) {
						row[key] = this.$moment().format('YYYYMMDD');
						// 불출일은 미래 날짜가 될 수 없습니다
						throw new Error(this.$sf_formatString(this.getMessage_('QWCC001781'), [this.getMessage_('QWCC001627')]));
					}
				}
				row[key] = value;
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			}
		},
		pvoAction() {
			try {
				const selectedPopupTableRows = this.$refs.popupTable.getSelectedRows();
				if (!selectedPopupTableRows.length) {
					throw new Error(this.getMessage_('QWCC001556'));
				}
				for (const el of selectedPopupTableRows) {
					this.schemaSave.validateSync(el);
				}
				const filtered = [...selectedPopupTableRows].map(row => {
					return {
						mesEqipNo: row.mesEqipNo,
						pvorId: row.pvorId,
						pwtiId: row.pwtiId,
						pvoDd: this.$moment(row.pvoDd).format('YYYYMMDD') + row.pvoDt,
						rmk: row.rmk
					};
				});
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.$sf_formatString(this.getMessage_('QWCC001654'), ['' + filtered.length]),
					buttons: [{ title: 'Ok', clickFn: () => this.sendPvo(filtered) }]
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			}
		},
		async sendPvo(row) {
			this.$sf_toggleLoading(true);
			try {
				const header = await this.savePvo_(row);
				if (header?.code == 0) {
					this.$sf_showMessage({
						icon: 'ok',
						message: this.getMessage_(header.messageCd),
						closeFn: this.close
					});
				} else {
					throw new Error(data?.header?.messageCd);
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		onUserPopup(userGbn, row) {
			this.selectedRow = row;
			this.$refs.userPopupView.open({ userGbn, userName: row[userGbn + 'Nm'] });
		},
		sendData(userData, userGbn) {
			this.selectedRow[userGbn + 'Id'] = userData.userId;
			this.selectedRow[userGbn + 'Nm'] = userData.userName;
		},
		onUserInPutKeyDown(userGbn) {
			this.selectedRow[userGbn + 'Id'] = '';
		}
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		schemaSave() {
			return Yup.object().shape({
				pwtiId: Yup.string() //인수자
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001632')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001632')])),
				pvorId: Yup.string() //불출자
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001633')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001633')])),
				pvoDd: Yup.date() //불출일
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001630')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001630')])),
				pvoDt: Yup.string() //불출시
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001631')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001631')]))
			});
		},
		columns() {
			return [
				{
					label: this.getMessage_('QWCC001317'), //관리번호
					prop: 'mesEqipNo'
				},
				{
					label: this.getMessage_('QWCC001314'), //장비명
					prop: 'mesEqipNm'
				},
				{
					label: this.getMessage_('QWCC001321'), //사용부서
					prop: 'useDeptNm',
					minWidth: '100px'
				},
				{
					label: this.getMessage_('QWCC000982'), //담당자
					prop: 'user1Id',
					minWidth: '1px'
				},
				{
					label: this.getMessage_('QWCC000982'), //담당자
					prop: 'user1Nm',
					minWidth: '100px'
				},
				{
					label: this.getMessage_('QWCC001315'), //가동상태
					prop: 'runStCd',
					form: {
						type: 'select',
						options: this.runStCdList,
						isDisabled: () => true
					}
				},
				{
					label: this.getMessage_('QWCC001316'), //교정상태
					prop: 'calStCd',
					form: {
						type: 'select',
						options: this.calStCdList,
						isDisabled: () => true
					}
				},
				{
					label: this.getMessage_('QWCC001632'), //인수자
					prop: 'pwtiId',
					minWidth: '1px'
				},
				{
					label: this.getMessage_('QWCC001632'), //인수자
					prop: 'pwtiNm',
					minWidth: '130px',
					custom: true
				},
				{
					label: this.getMessage_('QWCC001627'), //불출일자
					prop: 'pvoDd',
					minWidth: '120px',
					custom: true
				},
				{
					label: this.getMessage_('QWCC001629'), //불출시간
					prop: 'pvoDt',
					sortable: false,
					custom: true
				},
				{
					label: this.getMessage_('QWCC001633'), //불출자
					prop: 'pvorId',
					minWidth: '1px'
				},
				{
					label: this.getMessage_('QWCC001633'), //불출자
					prop: 'pvorNm',
					minWidth: '130px',
					custom: true
				},
				{
					label: this.getMessage_('QWCC000906'), //비고
					prop: 'rmk',
					minWidth: '380px',
					form: {
						type: 'input',
						maxlength: 66,
						placeholder: this.getMessage_('QWCC000906')
					}
				}
			];
		}
	}
};
</script>
